import { c as _c } from "react/compiler-runtime";
import { CRM_PIPELINE_API } from 'modules/crm/api/crm-pipeline-api';
import { PipelineStageInterface } from 'modules/crm/types/pipeline-interface';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { DataWithPaginationInterface } from 'shared/types/pagination-interface';
export function usePipelineStageList(id) {
  const $ = _c(7);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== id || $[2] !== user) {
    t1 = () => {
      if (user && id) {
        return `${CRM_PIPELINE_API}/${id}/stages/list-all`;
      }
    };
    $[1] = id;
    $[2] = user;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    data: pipelineStage,
    isLoading
  } = useControlledSwr(t1, fetcher, undefined, !!id);
  let t2;
  if ($[4] !== isLoading || $[5] !== pipelineStage) {
    t2 = {
      pipelineStage,
      isLoading
    };
    $[4] = isLoading;
    $[5] = pipelineStage;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}